module.exports = __webpack_public_path__ + "static/media/login-page.8a8462e8.jpeg";